import React, { memo } from 'react';
import { IconProps } from '.';

type CalendarIconProps = {
  color?: string;
} & IconProps;

export const CalendarIcon: React.FC<CalendarIconProps> = memo(
  ({ width = 20, height = 20, color = '#222427' }) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 20 20"
      >
        <path
          fill={color}
          d="M17.6 0H2.39A2.4 2.4 0 000 2.39v15.22A2.39 2.39 0 002.39 20H17.6a2.4 2.4 0 002.4-2.39V2.39A2.4 2.4 0 0017.6 0zm1.59 17.61a1.59 1.59 0 01-1.59 1.59H2.39A1.59 1.59 0 01.8 17.61V5.81h18.39v11.8zm0-12.61H.8V2.39A1.59 1.59 0 012.39.81H17.6a1.59 1.59 0 011.59 1.58V5z"
        ></path>
        <path
          fill={color}
          d="M7.98 16.53a2.441 2.441 0 002.63-2.37c0-1.44-1.22-2.1-2.6-2.22l2.32-2.57a.61.61 0 00.22-.44.39.39 0 00-.43-.38h-4.3a.41.41 0 00-.42.4.41.41 0 00.42.4h3.51l-2.3 2.59a.54.54 0 00-.18.35.38.38 0 00.39.38h.29c1.29 0 2.2.54 2.2 1.52a1.57 1.57 0 01-1.72 1.52 2.669 2.669 0 01-2.14-1 .5.5 0 00-.33-.13.45.45 0 00-.44.44.48.48 0 00.15.31A3.55 3.55 0 008 16.52M12.1 9.75h.19l1.11-.36v6.65a.44.44 0 00.44.44.44.44 0 00.43-.44V8.91a.43.43 0 00-.43-.44 1.58 1.58 0 00-.48.1l-1.3.45a.4.4 0 00-.31.38.38.38 0 00.38.38M6.47 1.97a1 1 0 100 2 1 1 0 000-2zm0 1.24A.21.21 0 016.26 3a.21.21 0 01.21-.22.22.22 0 110 .43zM14.75 1.97a1 1 0 100 2 1 1 0 000-2zm0 1.24a.21.21 0 01-.21-.21.21.21 0 01.21-.22.22.22 0 110 .43z"
        ></path>
      </svg>
    );
  }
);
